export default __webpack_public_path__ + "static/icon-30-4-7291dcb3e179e2a715c08b9b8b13fb33.png";